var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cf-node-properties__routing-filter" },
    [
      _c("FilterCriteria", {
        attrs: { "available-tags": _vm.availableTags },
        on: { change: _vm.handleCriteriaChange },
        model: {
          value: _vm.parsedCriteria,
          callback: function($$v) {
            _vm.parsedCriteria = $$v
          },
          expression: "parsedCriteria"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }